export type ScrollOptionsTypes = {
  top: number;
  left: number;
  behavior?: ScrollBehavior;
};

/**
 * Checks if the current browser supports the `scrollBehavior` CSS property.
 *
 * @returns {boolean} True if `scrollBehavior` is supported, otherwise false.
 */
export const isScrollBehaviorSupported = (): boolean => (
  'scrollBehavior' in document.documentElement.style
);

/**
 * Scrolls the window to the specified position, using smooth scrolling if supported.
 *
 * @param {ScrollOptionsTypes} options - Scrolling options.
 * If `scrollBehavior` is supported, `options` can include `{ top, left, behavior }`.
 * Otherwise, falls back to calling `window.scrollTo(x, y)` with `left` and `top`.
 *
 * @returns {void}
 */
export const windowScrollTo = (options: ScrollOptionsTypes): void => {
  if (isScrollBehaviorSupported()) {
    return window.scrollTo(options);
  }

  return window.scrollTo(options.left, options.top);
};
